import { Flex, Box, Card, Button, Skeleton, spaces } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { StyledItemGrid } from './ItemList';

type LoadingTextProps = {
  count?: number;
  height?: string | number;
  marginTop?: string | number;
};

const LoadingText = ({
  count = 1,
  height = '2rem',
  marginTop = '1rem',
}: LoadingTextProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} mt={marginTop} width="100%">
          <Skeleton height={height} />
        </Box>
      ))}
    </>
  );
};

const LoadingItemCard = () => {
  const { t } = useTranslation('storefront');
  return (
    <Card
      id="storefront-loading-card"
      width="100%"
      cardPadding={spaces.space_l}
      disabled>
      <Skeleton height="20rem" />
      <LoadingText count={5} />
      <Flex hAlignContent="center" mt="2rem" width="100%">
        <Button
          id="storefront-loading-button"
          buttonSize="large"
          fluid
          disabled>
          {t('common.addToCart')}
        </Button>
      </Flex>
    </Card>
  );
};

export const ItemListLoadingState = () => {
  return (
    <StyledItemGrid>
      <LoadingItemCard />
      <LoadingItemCard />
      <LoadingItemCard />
    </StyledItemGrid>
  );
};
